<template>
	<v-container
        fluid
        class="pl-0 pr-0"
    >
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-title class="text_primary">

                        <v-btn
                            class="text_default btn_default btn_default_bg_linear mr-3"
                            outlined
                            @click="toList"
                        >
                            返回
                        </v-btn> 

                        <v-spacer></v-spacer>
                        <v-btn
                            v-if="collector_id"
                            outlined
                            class="text_default btn_default btn_default_bg_linear mr-3"
                            @click="exportCode"
                        >
                            <v-icon>mdi-xml</v-icon>
                            取得嵌入原始碼
                        </v-btn>

                        <v-btn
                            v-if="collector_id"
                            class="btn_action btn_action_bg_linear"
                            outlined
                            @click="viewData()"
                        >
                            發票資料
                        </v-btn> 
                    </v-card-title>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense>
          <v-col cols="6">
                <v-card style="height:calc(100vh - 100px); overflow: scroll;">
                    <v-card-title class="text_primary">
                        基本設定
                        <v-spacer></v-spacer>



                        <v-btn
                            v-if="collector_id"
                            color="error"
                            class="white--text mr-3"
                            @click="delConfig"
                        >
                            刪除
                        </v-btn>

                        <v-btn
                            v-if="collector_id"
                            color="#5087e6"
                            class="white--text"
                            @click="saveConfig"
                        >
                            儲存
                        </v-btn>

                        <v-btn
                            v-else
                            color="#5087e6"
                            class="white--text"
                            @click="createConfig"
                        >
                            新增
                        </v-btn>



                    </v-card-title>
                    <v-card-text  class="pb-0">
                        <v-form ref="basic_form" lazy-validation @submit.prevent>
                            <v-row>
                                <v-col
                                    cols="12"
                                    class="pb-0"
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        名稱<span class="required_field">(必填)</span>:
                                    </h6>
                                    <v-text-field
                                        placeholder="11/11發票搜集活動"
                                        v-model="name"
                                        required
                                        height="12"
                                        dense
                                        outlined
                                        validate-on-blur
                                        :rules="[$utils.field_rules.required]"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row
                                class="pt-0 mt-0"
                            >
                                <v-col
                                    cols="12"
                                    lg="6"
                                    md="6"
                                    class="pb-0"
                                >
                                    <h6
                                        class="text-field-label"
                                    >
                                        開始時間<span class="required_field">(必填)</span>:
                                    </h6>
                                    <date-picker 
                                        :shortcuts="$utils.date_picker_shorcuts"
                                        class="date-picker"
                                        :class="{
                                            'datepicker-error' : error_message.start_at !== ''
                                        }"
                                        v-model="start_at" 
                                        type="datetime"
                                        @click="error_message.start_at = ''"
                                        @change="changeTimeField"
                                        @blur="changeTimeField"
                                    >
                                    </date-picker>
                                    <p
                                        class="mb-0 error_message"
                                        v-if="error_message.start_at"
                                    >{{error_message.start_at}}</p>
                                </v-col>

                                <v-col
                                    cols="12"
                                    lg="6"
                                    md="6"
                                    class="pb-0"
                                >
                                    <h6
                                        class="text-field-label"
                                    >
                                        結束時間<span class="required_field">(必填)</span>:
                                    </h6>
                                    <date-picker
                                        :shortcuts="$utils.date_picker_shorcuts" 
                                        @click="error_message.start_at = ''"
                                        class="date-picker "
                                        :class="{
                                            'datepicker-error' : error_message.start_at !== ''
                                        }"
                                        v-model="end_at" 
                                        type="datetime"
                                        @change="changeTimeField"
                                        @blur="changeTimeField"
                                    >
                                    </date-picker>
                                    <p
                                        class="mb-0 error_message"
                                        v-if="error_message.end_at"
                                    >{{error_message.end_at}}</p>
                                </v-col>

                            </v-row>
                            
                            <v-row>
                                <v-col
                                    cols="12"
                                    class=""
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        登入驗證:
                                    </h6>
                                    <v-select
                                        placeholder="11/11發票搜集活動"
                                        v-model="login_required"
                                        :items="login_items"
                                        height="12"
                                        dense
                                        hide-details
                                        outlined
                                        validate-on-blur
                                        :rules="[]"
                                    ></v-select>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col
                                    cols="12"
                                    class="pt-0"
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        傳統發票輸入方式:
                                    </h6>
                                    <v-select
                                        hide-details
                                        @input="changeField('value_method')"
                                        v-model="value_method"
                                        :items="value_methods"
                                        height="12"
                                        dense
                                        outlined
                                        validate-on-blur
                                        :rules="[$utils.field_rules.required]"
                                    ></v-select>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col
                                    cols="12"
                                    class="pt-0"
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        Facebook <span class="required_field">Pixel</span> Event:
                                    </h6>
                                    <v-select
                                        v-model="pixel_event"
                                        :items="pixel_events"
                                        height="12"
                                        dense
                                        outlined
                                        validate-on-blur
                                        :rules="[]"
                                        hide-details
                                    ></v-select>
                                </v-col>
                            </v-row>

                            <v-row
                                v-if="pixel_event === 'Custom'"
                            >
                                <v-col
                                    cols="12"
                                    class="pb-0 pt-0"
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        自訂事件名稱:
                                    </h6>
                                    <v-text-field
                                        placeholder="你要發送的自訂事件名稱 e.g. TestEvent"
                                        v-model="custom_event"
                                        required
                                        height="12"
                                        dense
                                        outlined
                                        validate-on-blur
                                        :rules="[]"
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col
                                    cols="12"
                                    class="pt-0"
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        是否發送CAPI事件:
                                    </h6>
                                    <v-select
                                        v-model="is_capi_activate"
                                        :items="capi_activates"
                                        height="12"
                                        dense
                                        outlined
                                        validate-on-blur
                                        :rules="[]"
                                        hide-details
                                    ></v-select>
                                </v-col>
                            </v-row>

                            <template v-if="is_capi_activate">
                                <v-row class="pb-0">
                                    <v-col
                                        cols="12"
                                        class="pb-0"
                                    >
                                        <h6

                                            class="text-field-label "
                                        >
                                            Pixel ID<span class="required_field">(必填)</span>:
                                        </h6>
                                        <v-text-field
                                            placeholder="你的facebook像素編號"
                                            v-model="pixel_id"
                                            height="12"
                                            dense
                                            outlined
                                            validate-on-blur
                                            required
                                            :rules="[$utils.field_rules.required,$utils.field_rules.isOnlyNumber]"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col
                                        cols="12"
                                        class="pt-0 pb-0"
                                    >
                                        <h6

                                            class="text-field-label "
                                        >
                                            Facebook <span class="required_field">CAPI</span> Event:
                                        </h6>
                                        <!-- {{c_pixel_event}} -->
                                        <v-select
                                            v-model="c_pixel_event"
                                            :items="pixel_events"
                                            height="12"
                                            dense
                                            outlined
                                            hide-details
                                            validate-on-blur
                                            :rules="[]"
                                        ></v-select>
                                    </v-col>
                                </v-row>

                                <v-row class="pb-0">
                                    <v-col
                                        cols="12"
                                    >
                                        <h6

                                            class="text-field-label "
                                        >
                                            CAPI Token:
                                        </h6>
                                        <v-select
                                            v-model="secret_token_id"
                                            :items="container_tokens"
                                            height="12"
                                            dense
                                            outlined
                                            hide-details
                                            item-text="token_name"
                                            item-value="id"
                                            validate-on-blur
                                            required
                                            :rules="[$utils.field_rules.required]"
                                        ></v-select>
                                    </v-col>
                                </v-row>

                                <v-row>
                                    <v-col
                                        cols="12"
                                        class="pt-0"
                                    >
                                        <h6

                                            class="text-field-label "
                                        >
                                            事件時間(event_time):
                                        </h6>
                                        <v-select
                                            v-model="event_time_mode"
                                            :items="event_time_modes"
                                            height="12"
                                            dense
                                            outlined
                                            validate-on-blur
                                            :rules="[]"
                                            return-object
                                            :hint="event_time_mode.hint"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                            </template>
                        </v-form>
                    </v-card-text>
                    <v-card-title class="text_primary">樣式設定</v-card-title>
                    <v-card-text  class="pb-0">
                        <v-form ref="style_form" lazy-validation @submit.prevent>
                            <v-row>
                                <v-col
                                    cols="12"
                                    class="pb-0 pt-0"
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        發票蒐集器大小:
                                    </h6>
                                    <v-select
                                        v-model="selected_size_item"
                                        :items="size_items"
                                        height="12"
                                        dense
                                        outlined
                                        hide-details
                                        validate-on-blur
                                        :rules="[$utils.field_rules.required]"
                                    ></v-select>
                                </v-col>
                            </v-row>

                            <v-row
                                v-if="selected_size_item === 'image'"
                            >
                                <v-col
                                    cols="12"
                                    class="pb-0"
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        背景圖片<span class="required_field">(必填)</span>:
                                    </h6>
                                    <v-text-field
                                        placeholder=""
                                        v-model="bg_src"
                                        height="12"
                                        dense
                                        outlined
                                        :rules="[]"
                                        hide-details
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row
                            >
                                <v-col
                                    cols="6"
                                    class="pb-0"
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        寬<span class="required_field">(必填)</span>:
                                    </h6>
                                    <v-text-field
                                        :suffix="'%'"
                                        type="number"
                                        placeholder=""
                                        v-model="frame_width"
                                        height="12"
                                        min="0"
                                        max="100"
                                        dense
                                        outlined
                                        :rules="[$utils.field_rules.required]"
                            
                                    ></v-text-field>
                                </v-col>

                                <v-col
                                    cols="6"
                                    class="pb-0"
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        高<span class="required_field">(必填)</span>:
                                    </h6>
                                    <v-text-field
                                        :suffix="unit"
                                        type="number"
                                        placeholder=""
                                        v-model="frame_height"
                                        height="12"
                                        dense
                                        outlined
                                        min="0"
                                        :rules="[$utils.field_rules.required]"
                    
                                    ></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col
                                    cols="12"
                                    class="pb-0"
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        背景顏色 <span class="required_field">(必填)</span>:
                                    </h6>
                                    <v-text-field
                                        v-model="bg_color" 
                                        height="12"
                                        dense
                                        outlined
                                        class="text-field-input"
                                        @input="changeField('bg_color')"
                                        :rules="[$utils.field_rules.required]"
                                    >
                                        <template v-slot:append>
                                            <ColorPicker
                                                :colorValue="bg_color"
                                                @updateColorValue="changeColor('bg_color',$event)"
                                            />
                                        </template>    
                                    </v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col
                                    cols="12"
                                    class="pb-0"
                                >
                                    <h6

                                        class="text-field-label "
                                    >
                                        主題顏色 <span class="required_field">(必填)</span>:
                                    </h6>
                                    <v-text-field
                                        v-model="theme_color" 
                                        height="12"
                                        dense
                                        outlined
                                        class="text-field-input"
                                        @input="changeField('theme_color')"
                                        :rules="[$utils.field_rules.required]"
                                    >
                                        <template v-slot:append>
                                            <ColorPicker
                                                :colorValue="theme_color"
                                                @updateColorValue="changeColor('theme_color', $event)"
                                            />
                                        </template>    
                                    </v-text-field>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-title class="text_primary">內文</v-card-title>
                    <v-card-text  class="pb-6">
                        <Editor 
                            :init="init"
                            v-model="title_html"
                            @input="changeField('title_html')"
                        >
                        </Editor>
                    </v-card-text>
                </v-card>
          </v-col>

          <v-col
            cols="6"
          >

            <div ref="output" style="position:relative;display: inline-block; width:100%;text-align:center;">
                <img v-if="selected_size_item === 'image'" :src="bg_src" style="width: 100%;">
                <iframe 
                    ref="iframe"
                    allow="camera *"
                    :src="iframe_src" 
                    style="border:0px;top: 50%;left: 50%;right: 0px;bottom: 0px;overflow-y:scroll;"
                    :style="{
                        transform: selected_size_item === 'image' ? 'translate(-50%, -50%)' : '',
                        position: selected_size_item === 'image' ? 'absolute': '',
                        width: `${frame_width}%`,
                        height: `${frame_height}${unit}`,
                        top: '50% !important',
                        left: '50% !important',
                    }"
                >
                </iframe>
            </div>
          </v-col>

        </v-row>
		<CodeCopyDialog 
			:setting="code_copy_setting"
		>

		</CodeCopyDialog>
	</v-container>
</template>
<script>
// import 子組件
import CodeCopyDialog from "@/components/Utils/CodeCopyDialog.vue";
import ColorPicker from "@/components/Utils/ColorPicker.vue"
// DatePicker!
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-tw';
import { 
    apiGetInvoiceCollector,
    apiUpdateInvoiceCollector,
    apiCreateInvoiceCollector,
    apiDeleteInvoiceCollector
} from '@/api/urlview.js'

import {
    apiGetContainerToken,
} from '@/api/container.js'

// 引入tinymce編輯器
import tinymce from 'tinymce/tinymce'
import Editor from '@tinymce/tinymce-vue'
import 'tinymce/themes/silver/theme.min.js'
import 'tinymce/icons/default'
import 'tinymce/skins/ui/oxide/skin.min.css'	
import 'tinymce/plugins/image'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/visualblocks'

	export default {
		name: 'InvoiceEditor',
        props: {
        },
		components: {
            DatePicker,ColorPicker,Editor,CodeCopyDialog
		},
		data: function() {
			return {	
                collector_id: '',
                name: '',
                start_at: '',
                end_at: '',
                error_message: {
                    start_at: '',
                    end_at: '',
                },
                login_required: false,
                login_items: [
                    {
                        text: '開啟',
                        value: true,
                    },
                    {
                        text: '關閉',
                        value: false,
                    }
                ],
                iframe_src: '',
                selected_size_item: 'custom',
                size_items: [
                    {
                        text: '依據背景圖片',
                        value: 'image',
                    },
                    {
                        text: '自訂大小',
                        value: 'custom',
                    }
                ],
                unit: 'px',
                bg_src: '',
                frame_width: '82',
                frame_height: '400',
                value_method: 'cost',
                value_methods: [
                    {
                        "text": "消費金額",
                        "value": 'cost'
                    },
                    {
                        "text": "消費品項",
                        "value": 'item'
                    }
                ],
                bg_color: '#e3a7d6',
                theme_color: '#af2c88',

                /* tinymce輸入內容的變數 */
                title_html: '<p>內文</p>',

                /* tinymce初始設定檔 */
                init: {
                    selector: '#tinymce',
                    language_url: '/tinymce/langs/zh_TW.js',
                    language: 'zh_TW', 
                    skin_url: '/tinymce/skins/ui/oxide',
                    height: "200px",
                    branding: false,
                    menubar: false,
                    plugins: 'link,lineheight',
                    toolbar:'undo redo| fontsizeselect | forecolor |  bold italic underline | link |lineheightselect | alignleft aligncenter alignright alignjustify',
                    content_style: "p { margin:0px;padding:0px; line-height: 1.3;}",
                    lineheight_formats: "1pt 2pt 3pt 4pt 5pt 6pt 7pt 8pt 9pt 10pt 11pt 12pt 13pt 14pt 15pt 16pt 17pt 18pt 20pt 22pt 24pt 26pt",		
                    external_plugins: {
                        'lineheight': '/tinymce/lineheight/plugin.js'
                    },
                },
                save_fields: [
                    'name', 'login_required', 'value_method',
                    'selected_size_item', 'bg_src',
                    'frame_width', 'frame_height',
                    'bg_color', 'theme_color',
                    'title_html','pixel_event', 'custom_event',
                    'is_capi_activate'
                ],
				code_copy_setting: {
                    width: 800,
					html_code : '',
					is_show: false,
					title: '在頁面嵌入發票蒐集器',
					subtitle: '請將這段程式碼放在網頁想要顯示的區塊中 :',
					description: '',
				},
                pixel_event: '',
                pixel_events: [
                    {
                        text: '無',
                        value: '',
                    },
                    {
                        text: 'AddPaymentInfo',
                        value: 'AddPaymentInfo',
                    },
                    {
                        text: 'AddToCart',
                        value: 'AddToCart',
                    },
                    {
                        text: 'AddToWishlist',
                        value: 'AddToWishlist',
                    },
                    {
                        text: 'CompleteRegistration',
                        value: 'CompleteRegistration',
                    },
                    {
                        text: 'Contact',
                        value: 'Contact',
                    },
                    {
                        text: 'CustomizeProduct',
                        value: 'CustomizeProduct',
                    },
                    {
                        text: 'Donate',
                        value: 'Donate',
                    },
                    {
                        text: 'FindLocation',
                        value: 'FindLocation',
                    },
                    {
                        text: 'InitiateCheckout',
                        value: 'InitiateCheckout',
                    },
                    {
                        text: 'Lead',
                        value: 'Lead',
                    },
                    {
                        text: 'Purchase',
                        value: 'Purchase',
                    },
                    {
                        text: 'Schedule',
                        value: 'Schedule',
                    },
                    {
                        text: 'Search',
                        value: 'Search',
                    },
                    {
                        text: 'StartTrial',
                        value: 'StartTrial',
                    },
                    {
                        text: 'SubmitApplication',
                        value: 'SubmitApplication',
                    },
                    {
                        text: 'Subscribe',
                        value: 'Subscribe',
                    },
                    {
                        text: 'ViewContent',
                        value: 'ViewContent',
                    }
                ],
                custom_event: '',

                is_capi_activate: false,
                capi_activates: [
                    {
                        text: '開啟',
                        value: true
                    },
                    {
                        text: '關閉',
                        value: false
                    }
                ],
                capi_token: "",
                c_pixel_event: "",
                pixel_id: "",
                event_time_mode: 0,
                event_time_modes: [
                    {
                        text: '方式一',
                        value: 0,
                        hint: '發票日期超過七天不送CAPI事件',
                    },
                    {
                        text: '方式二',
                        value: 1,
                        hint: '發票日期超過七天的改成目前時間 - 7天, 未超過的照發票日期'
                    },
                    {
                        text: '方式三',
                        value: 2,
                        hint: '一率為目前時間'
                    }
                ],

                container_tokens: [],
                secret_token_id: '',
			}
		},
        created: async function(){
        },
		mounted: async function() {
            let id = this.$route.params.id
            if (isNaN(id)) {
                id = ''
            }
            this.collector_id = id
            this.iframe_src = `${window.location.protocol}//${window.location.host}/embed/invoice_collector?id=${id}&is_edit=true&container_id=${this.$route.params.container_id}`
            tinymce.init({});


            if (id) {
                this.getData(id)
            }

            try {
                let result = await apiGetContainerToken(
                    this.$route.params.org_id, this.$route.params.container_id
                )
                let tokens = result.data
                this.container_tokens = tokens
                console.log('token_result', tokens)
            } catch (error) {
                console.error('取得token失敗',error)
            }
		},
        destroyed: function(){
        },
		methods: {
            async getData(id){
                try {
                    let result = await apiGetInvoiceCollector(id)
                    let column = JSON.parse(result.data.add_column)
                    console.log('column',column)
                    console.log('result',result.data)
                    this.start_at = new Date(result.data.start_at)
                    this.end_at = new Date(result.data.end_at)
                    this.save_fields.forEach((field) => {
                        if (column[field] !== undefined && column[field] !== null){
                            this[field] = column[field]
                        }
                    })
                    this.capi_token = result.data.token_display
                    this.secret_token_id = result.data.secret_token_id
                    this.c_pixel_event = result.data.pixel_event
                    this.event_time_mode = this.event_time_modes.find(mode => {
                        return mode.value ===result.data.event_time_mode
                    }) 
                    this.pixel_id = result.data.pixel_id

                    
                    this.$store.commit('update_breadcrumbs',[
                        {
                            "text": "頁面優化",
                            disabled: true,
                        },
                        {
                            "text": "發票蒐集器",
                            disabled: false,
                            href: `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/invoice_collector/`
                        },
                        {
                            "text": result.data.ict_name,
                        }
                    ])

                } catch (error) {
					this.$root.vtoast.show({
						message: `取得設定檔失敗，原因: ${error}`
					})

                    if (error.includes('not found')) {
                        this.$router.replace(
                            `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/invoice_collector/`
                        )
                    }
                }
            },
            changeTimeField(){
                // 檢查start_at / end_at 是不是空的
                if (!this.start_at) {
                    this.error_message.start_at = '必填欄位'
                }
                else {
                    this.error_message.start_at = ''
                }
                if (!this.end_at) {
                    this.error_message.end_at = '必填欄位'
                }
                else {
                    this.error_message.end_at = ''
                }

                // 檢查 start_at 是否大於 end at
                if (this.start_at && this.end_at) {
                    if (new Date(this.start_at).getTime() > new Date(this.end_at).getTime()) {
                        this.error_message.end_at = '不能比開始時間早'
                    }
                    else {
                        this.error_message.end_at = ''
                    }
                }
            },
            changeColor(field, event){
                this[field] = event
                this.changeField(field)
            },
            changeField(field){
                console.log('field', field)
                console.log('vale',this[field])
                let params = {
                    action: 'change_style',
                    field: field,
                    value: this[field]
                }
                this.$refs.iframe.contentWindow.postMessage(params, '*');
            },
            async saveConfig(){
                this.changeTimeField()
                let basic_result = this.$refs.basic_form.validate()
                let style_result = this.$refs.style_form.validate()

                if (basic_result !== true || style_result !== true) {
					this.$root.vtoast.show({
						message: `請檢查必填欄位是否填寫。`
					})
                    return
                }

                if (!this.start_at || !this.end_at) {
					this.$root.vtoast.show({
						message: `請檢查必填欄位是否填寫。`
					})
                    return
                }
                this.$root.vprogress.init({
                    message: '保存中...',
                })
                this.$root.vprogress.show()
                let params = {
                    start_at: this.start_at.toISOString(),
                    end_at: this.end_at.toISOString(),
                    ict_name: this.name,
                    pixel_event: this.is_capi_activate ? this.c_pixel_event: '',
                    event_time_mode: this.is_capi_activate  ? this.event_time_mode.value : '',
                    pixel_id: this.is_capi_activate ?  this.pixel_id : '',
                    secret_token_id: this.is_capi_activate ? this.secret_token_id : 0,
                }

                if (!this.is_capi_activate) {
                    delete params['secret_token_id']
                }

                let add_column = {}
                this.save_fields.forEach((field) => {
                    if (this[field] !== undefined && this[field] !== null) {
                        add_column[field] = this[field]
                    }
                    else {
                        add_column[field] = ''
                    }
                })

                console.log('params',params)
                console.log('add_column',add_column)
                params['id'] = parseInt(this.collector_id)
                params['add_column'] = JSON.stringify(add_column)

                try {
                    let result = await apiUpdateInvoiceCollector(
                        this.$route.params.org_id,
                        params
                    )
                    console.log('result', result)
					this.$root.vtoast.show({
						message: `保存成功！`,
                        color: 'primary'
					})
                    this.$root.vprogress.hide()
                    this.getData(this.collector_id)
                } catch (error) {
					this.$root.vtoast.show({
						message: `保存失敗，原因: ${error}`
					})
                }

                this.$root.vprogress.hide()
            },
            async delConfig(item){
                console.log('item',item)
                let t_confirm = confirm('確定要刪除?')
                if (t_confirm) {
                    this.$root.vprogress.init({
                        message: '刪除中...',
                        color: 'primary'
                    })
                    this.$root.vprogress.show()

                    try {
                        let result = await apiDeleteInvoiceCollector(
                            this.$route.params.org_id, this.$route.params.id
                        )
                        console.log('result', result)
                        this.$root.vprogress.hide()
                        this.$root.vtoast.show({
                            message: `刪除成功！`,
                            color: 'primary'
                        })
                        this.$router.replace(
                            `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/invoice_collector/`
                        )
                    } catch (error) {
                        this.$root.vprogress.hide()
                        this.$root.vtoast.show({
                            message: `刪除失敗，原因: ${error}`
                        })
                        
                    }
                    
                }
            },
            async createConfig(){
                this.changeTimeField()
                let basic_result = this.$refs.basic_form.validate()
                let style_result = this.$refs.style_form.validate()

                if (basic_result !== true || style_result !== true) {
					this.$root.vtoast.show({
						message: `請檢查必填欄位是否填寫。`
					})
                    return
                }

                if (!this.start_at || !this.end_at) {
					this.$root.vtoast.show({
						message: `請檢查必填欄位是否填寫。`
					})
                    return
                }

                let params = {
                    start_at: this.start_at.toISOString(),
                    end_at: this.end_at.toISOString(),
                    ict_name: this.name,
                    pixel_event: this.is_capi_activate ? this.c_pixel_event: '',
                    secret_token_id: this.is_capi_activate ? this.secret_token_id : 0,
                    event_time_mode: this.is_capi_activate ? this.event_time_mode.value : '',
                    pixel_id: this.is_capi_activate ? this.pixel_id : ''
                }
                if (!this.is_capi_activate) {
                    delete params['secret_token_id']
                }
                let add_column = {}
                this.save_fields.forEach((field) => {
                    if (this[field] !== undefined && this[field] !== null) {
                        add_column[field] = this[field]
                    }
                    else {
                        add_column[field] = ''
                    }
                })

                console.log('params',params)
                console.log('add_column',add_column)
                params['container_id'] = this.$route.params.container_id
                params['add_column'] = JSON.stringify(add_column)

                try {
                    let result = await apiCreateInvoiceCollector(
                        this.$route.params.org_id,
                        params
                    )
                    console.log('result', result)
					this.$root.vtoast.show({
						message: `新增成功！`,
                        color: 'primary'
					})

                    let path = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/invoice_collector/${result.data.id}`
                    this.$router.replace(path)
                    // this.getData(this.collector_id)
                } catch (error) {
					this.$root.vtoast.show({
						message: `新增失敗，原因: ${error}`
					})
                }

            },
            exportCode(){
                console.log('export')
				this.code_copy_setting.is_show = true
                console.log(this.$refs.output.outerHTML)
                let code = this.$refs.output.outerHTML.replaceAll('amp;is_edit=true&amp;', '')
				this.code_copy_setting.html_code = code
            },
            viewData(){
				let path = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/invoice_collector/${this.$route.params.id}/data`
				this.$router.push(path)
            },
            toList(){
                let path = `/${this.$route.params.org_id}/${this.$route.params.container_id}/optimize_page/invoice_collector/`
                this.$router.push(path)
            }
        },
        watch: {
            selected_size_item:function(){
                if (this.selected_size_item === 'image') {
                    this.unit = '%'
                    if (this.frame_height > 100) {
                        this.frame_height = 80
                    }
                }
                else {
                    this.unit = 'px'
                    if (this.frame_height < 100) {
                        this.frame_height = 300
                    }
                }
            }
        }
    }
</script>
<style scoped>
.date-picker.mx-datepicker {
    width: 100%;
}
.date-picker >>> .mx-input-wrapper > .mx-input  {
    border-width: 1px !important;
    border-color: rgba(0, 0, 0, 0.38) !important;
}
.error_message {
    font-size: 12px;
    line-height: 12px;
    padding-left: 12px;
    padding-top:5px;
    color: red;
}
.datepicker-error >>> .mx-input-wrapper > .mx-input {
   border: 2px solid red !important;
}
.required_field {
    color: red;
}
.text-field-input >>> .v-input__control > .v-input__slot > .v-input__append-inner {
    margin-top: 5px !important; 
}
</style>